import { Button } from '../input';
import { track } from '../track';
import { BillingCheckoutModal } from './BillingCheckoutModal';

const cardStyle = {
  border: '1px solid #ddd',
  borderRadius: 8,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 480,
  background: 'white',
};

const headerStyle = {
  padding: 18,
  borderBottom: '1px solid #eee',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
};

const badgeStyle = {
  alignSelf: 'flex-start',
  border: '1px solid #fed7aa',
  borderRadius: 999,
  padding: '3px 8px',
  color: '#c2410c',
  background: '#fff7ed',
  fontSize: 12,
  fontWeight: 'bold',
};

const priceStyle = {
  fontSize: 30,
  fontWeight: 'bold',
};

const rowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 14,
  padding: '10px 0',
  borderBottom: '1px solid #f0f0f0',
  lineHeight: 1.35,
};

const ActionButton = ({ plan, onSuccess }) => {
  const button = (
    <Button
      style={{ width: '100%' }}
      href={plan.href}
      onClick={() => track('billing/plan_button_click', { plan: plan.id })}
    >
      {plan.buttonLabel}
    </Button>
  );

  if (plan.href) {
    return button;
  }

  return (
    <BillingCheckoutModal plan={plan} onSuccess={onSuccess}>
      {button}
    </BillingCheckoutModal>
  );
};

export const BillingPlanCard = ({ plan, onSuccess }) => {
  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <div style={badgeStyle}>{plan.badge}</div>
        <div>
          <div style={{ fontSize: 20, fontWeight: 'bold' }}>{plan.title}</div>
          <div style={{ color: '#666', marginTop: 6, minHeight: 38, lineHeight: 1.35 }}>{plan.subtitle}</div>
        </div>
        <div style={priceStyle}>{plan.price}</div>
      </div>

      <div style={{ padding: '8px 18px 18px', flex: 1 }}>
        {plan.rows.map(([label, value]) => (
          <div key={label} style={rowStyle}>
            <span style={{ color: '#666' }}>{label}</span>
            <strong style={{ textAlign: 'right' }}>{value}</strong>
          </div>
        ))}
      </div>

      <div style={{ padding: 18, borderTop: '1px solid #eee' }}>
        <ActionButton plan={plan} onSuccess={onSuccess} />
      </div>
    </div>
  );
};
